// Shared types + enum option lists for the CMZ Islamic Quotes library.

export type QuoteCategory =
  | "QURAN"
  | "HADITH"
  | "DUA"
  | "ADHKAAR"
  | "REMINDER"
  | "WISDOM";

export const QUOTE_CATEGORIES: QuoteCategory[] = [
  "QURAN",
  "HADITH",
  "DUA",
  "ADHKAAR",
  "REMINDER",
  "WISDOM",
];

// Human-friendly labels for the enum values.
export const CATEGORY_LABELS: Record<QuoteCategory, string> = {
  QURAN: "Quran",
  HADITH: "Hadith",
  DUA: "Dua",
  ADHKAAR: "Adhkaar",
  REMINDER: "Reminder",
  WISDOM: "Wisdom",
};

export type IslamicQuote = {
  id: string;
  source: "CMZ_LIBRARY" | "CUSTOM";
  category: QuoteCategory;
  // For QURAN quotes these are null — text is fetched via cmz-backend
  // Quran Foundation Content proxy using surahNumber/ayahNumber.
  // Populated for all other categories.
  arabicText?: string | null;
  translation?: string | null;
  transliteration?: string | null;
  reference: string;
  surahNumber?: number | null;
  ayahNumber?: number | null;
  tags: string[];
  labels: string[];
  createdBy?: string | null;
  isVerified: boolean;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type IslamicQuoteConnection = {
  quotes: IslamicQuote[];
  totalCount: number;
  hasMore: boolean;
};

export type IslamicQuoteFilterInput = {
  category?: QuoteCategory;
  tag?: string;
  label?: string;
  searchTerm?: string;
  page?: number;
  limit?: number;
};

export type CreateCMZLibraryQuoteInput = {
  category: QuoteCategory;
  // QURAN → send surahNumber + ayahNumber (text fetched client-side).
  // Other categories → send arabicText + translation.
  arabicText?: string;
  translation?: string;
  transliteration?: string;
  reference: string;
  surahNumber?: number;
  ayahNumber?: number;
  tags: string[];
  labels?: string[];
};

export type UpdateCMZLibraryQuoteInput = {
  id: string;
  category?: QuoteCategory;
  arabicText?: string;
  translation?: string;
  transliteration?: string;
  reference?: string;
  surahNumber?: number;
  ayahNumber?: number;
  tags?: string[];
  labels?: string[];
  isVerified?: boolean;
  isActive?: boolean;
};

// ─── Quote of the Day ─────────────────────────────────────────────────────────
export type QuoteOfTheDaySchedule = {
  id: string;
  date: string; // YYYY-MM-DD
  quoteId: string;
  isGlobal: boolean;
  quote: IslamicQuote;
};

export type ScheduleQuoteOfTheDayInput = {
  date: string; // YYYY-MM-DD
  quoteId: string;
};
